import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi } from '../api/admin';
import { format } from 'date-fns';
import './TablePage.css';

interface UserRow {
  id: string;
  phone: string;
  kakaoId?: string;
  isOnboarded: boolean;
  sentPicks: number;
  receivedPicks: number;
  createdAt: string;
}

export default function UsersPage() {
  const [users, setUsers] = useState<UserRow[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [loading, setLoading] = useState(true);
  const [kakaoEnabled, setKakaoEnabled] = useState(false);
  const navigate = useNavigate();

  const load = useCallback(async () => {
    setLoading(true);
    const data = await adminApi.getUsers(page, 20, search || undefined);
    setUsers(data.data);
    setTotal(data.total);
    setTotalPages(data.totalPages);
    if (data.kakaoEnabled !== undefined) setKakaoEnabled(data.kakaoEnabled);
    setLoading(false);
  }, [page, search]);

  useEffect(() => { load(); }, [load]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setPage(1);
    setSearch(searchInput);
  };

  return (
    <div className="table-page">
      <div className="page-header">
        <h2>유저 관리 <span className="count">({total.toLocaleString()})</span></h2>
        <form onSubmit={handleSearch} className="search-form">
          <input
            placeholder="전화번호 검색"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
          />
          <button type="submit">검색</button>
        </form>
      </div>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>전화번호</th>
              {kakaoEnabled && <th>카카오</th>}
              <th>온보딩</th>
              <th>보낸 픽</th>
              <th>받은 픽</th>
              <th>가입일</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={kakaoEnabled ? 7 : 6} className="center">로딩 중...</td></tr>
            ) : users.length === 0 ? (
              <tr><td colSpan={kakaoEnabled ? 7 : 6} className="center">데이터 없음</td></tr>
            ) : users.map((u) => (
              <tr key={u.id} onClick={() => navigate(`/users/${u.id}`)} className="clickable">
                <td>{u.phone}</td>
                {kakaoEnabled && <td>{u.kakaoId ? u.kakaoId.slice(0, 8) + '...' : '-'}</td>}
                <td><span className={`badge ${u.isOnboarded ? 'green' : 'gray'}`}>{u.isOnboarded ? '완료' : '미완료'}</span></td>
                <td>{u.sentPicks}</td>
                <td>{u.receivedPicks}</td>
                <td>{format(new Date(u.createdAt), 'yyyy-MM-dd HH:mm')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="pagination">
        <button disabled={page <= 1} onClick={() => setPage(page - 1)}>이전</button>
        <span>{page} / {totalPages}</span>
        <button disabled={page >= totalPages} onClick={() => setPage(page + 1)}>다음</button>
      </div>
    </div>
  );
}
